import { Stack } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { memo } from "react";
import ScoringChart from "./ScoringChart";
import ScoringOverviewStats from "./ScoringOverviewStats";

const ScoringStats = ({comments}: {comments: any[]}) => {
    const theme = useTheme();
    return (
        <Stack
            direction="row"
            sx={{
                width: "100%",
                border: `1px solid ${theme?.custom?.borderGrey}`,
                borderRadius: "4px",
                flexWrap: "wrap",
                overflow: "hidden",
            }}
        >
            <ScoringChart comments={comments} />
            <ScoringOverviewStats />
        </Stack>
    );
};

export default memo(ScoringStats);
